import React, {PropsWithChildren, useContext, useMemo} from "react"
import {AxiosError, InternalAxiosRequestConfig} from "axios";
import { acquireAccessToken } from "../auth";
import { axiosInstance } from "./axios-config";
import PageContext from "../../components/Common/PageContext";

export const AxiosInterceptors: React.FC<PropsWithChildren<any>> = ({ children }) => {
  const [pageContext] = useContext(PageContext);
  
  useMemo(() => {
    const addProfileHeaders = async (axiosConfig: InternalAxiosRequestConfig<any>): Promise<InternalAxiosRequestConfig<any>> => {
      const token = await acquireAccessToken();

      axiosConfig.headers['Authorization'] = `Bearer ${token}`;

      return axiosConfig;
    }

    const addMultiTenancyHeaders = async (axiosConfig: InternalAxiosRequestConfig<any>): Promise<InternalAxiosRequestConfig<any>> => {
      const { countryCode } = pageContext.userInformation;

      axiosConfig.headers['x-jbg-company'] = "Jbh";
      axiosConfig.headers['x-jbg-country'] = countryCode === "" ? "Au" : countryCode;

      return axiosConfig;
    }

    const onRejected = (error: AxiosError): Promise<AxiosError> => {
      return Promise.reject(error);
    }

    axiosInstance.interceptors.request.clear();
    axiosInstance.interceptors.request.use(addProfileHeaders, onRejected);
    axiosInstance.interceptors.request.use(addMultiTenancyHeaders, onRejected);
  }, [pageContext.userInformation]);

  return <>{children}</>;
}